import chairman from "../../assets/images/about/Chairman.jpg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Circle } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
type Props = {};

const data = {
  img: chairman,
  title:
    "Prof. Dr. Gajanan R. Ekbote M.S., M.N.A. M.S. MChairman, P.E. Society, Pune 5",
  description:
    "He was the man behind the great edifice of today's Progressive Education Society's glorious achievements. What Dr. Gajanan R. Ekbote Believes split\"I have always believed that the answer to my destiny lies in creating the results, I desire!\"splitAbout Dr Gajanan R. Ekbote.splitA surgeon by profession, Dr.Gajanan R. Ekbote made his foray into the world of administration in 1985. Fuelled by the desire for pedagogical pursuits, he accepted the challenging responsibility of leading the Progressive Education Society, Pune as its chairman. In order to keep pace with the changing scenario of education, he has introduced emerging and need-based courses in the institutions run by Progressive Education Society. It is an account of his pro-active approach and foresightedness that he has been successfully leading 56 educational institutions in Pune City. Dr.G.R.Ekbote was granted an equivalence of Ph.D degree by Maharashtra University of Health Sciences, Nashik for his outstanding academic qualifications, research work and eminence achieved in his profession. Presently, he is working as the Pro-Vice Chancellor of the same University.",
  headings: ["About Chariman", "Chairman Profile"],
  career: [
    "Professor of Surgery- B.J Medical College, Pune",
    "Dean, Faculty of Medicine - Savitribai Phule Pune University, Pune",
    "Appointed as a Member of Consultative Group on 'Education' by planning commission, Govt. of India.",
    "Appointed as a Member of Consultative Group on 'Teacher's Education' by planning commission, Govt. of India.",
    "Member, Senate and Board of College and University Development - Savitribai Phule Pune University",
    "Member, Management Council (Chancellor's Nominee) - Senate and Academic Council Maharashtra University of Health Sciences, Nashik",
    "Member, Board of Governors- National Institute of Technology, Surathkal, Karnataka",
    "Member, Academic Council (UGC Nominee) -West Bengal University of Health Sciences, Kolkata",
    "Ex-Pro-Vice chancellor of Maharashtra University of Health Sciences, Nashik.",
  ],
};
const Chairman = (props: Props) => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Grid container>
          <Grid item xs={12} py="2rem" textAlign="center">
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                display: "inline",
                textDecoration: "underline",
                textUnderlineOffset: "6px",
                fontWeight: "600",
              }}
            >
              Our Chairman
            </Typography>
          </Grid>

          <Grid
            container
            justifyContent={"center"}
            alignItems={"start"}
            xs={12}
            md={4}
          >
            <Card
              sx={{
                width: { xs: "80%", md: "80%" },
                position: "sticky",
                top: "130px",
                transform: "translateY(-4rem)",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  p: "1.5rem",
                }}
              >
                <img
                  src={chairman}
                  alt="pricipal"
                  style={{
                    width: "110%",
                    height: "110%",
                    top: "30%",
                  }}
                />
                <Typography
                  variant="body2"
                  textAlign="center"
                  color={"primary.main"}
                  sx={{ px: { xs: "2rem", md: "0rem" }, pt: "10px" }}
                >
                  <span style={{ fontSize: "16px" }}>
                    Prof. Dr. Gajanan R. Ekbote
                  </span>
                  <br />
                  <span>M.S., M.N.A. M.S.M Chairman,P.E. Society</span>
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={8}>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{ px: { xs: "2rem", md: "0rem" } }}
              fontSize={"1rem"}
            >
              He is the man behind the great edifice of today's Progressive
              Education Society's glorious achievements. What Dr. Gajanan R.
              Ekbote Believes
            </Typography>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{ px: { xs: "2rem", md: "0rem" } }}
              fontSize={"1rem"}
            >
              "I have always believed that the answer to my destiny lies in
              creating the results, I desire!"
            </Typography>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{ px: { xs: "2rem", md: "0rem" } }}
              fontSize={"1rem"}
            >
              About Dr Gajanan R. Ekbote. :
            </Typography>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{ px: { xs: "2rem", md: "0rem" }, textIndent: "2rem" }}
              fontSize={"1rem"}
            >
              A surgeon by profession, Prof. Dr. Gajanan Ramakant Ekbote made
              his foray into the world of administration in 1985. Fuelled by the
              desire for pedagogical pursuits, he accepted the challenging
              responsibility of leading the Progressive Education Society, Pune
              as its chairman. In order to keep pace with the changing scenario
              of education, he has introduced emerging and need-based courses in
              the institutions run by Progressive Education Society. It is on
              account of his proactive approach and foresightedness that he has
              been successfully leading more than 62 Educational Institutions in
              Pune City. Prof. Dr. Gajanan Ekbote was granted an equivalence of
              Ph.D. Degree by Maharashtra University of Health Sciences, Nashik
              for his outstanding academic qualifications, research work and
              eminence achieved in his profession.
            </Typography>
            <Accordion sx={{ mb: "2rem" }} defaultExpanded>
              <AccordionSummary
                id="panel1-header"
                expandIcon={<ExpandMoreIcon />}
              >
                <Typography
                  variant="body2"
                  color={"primary.main"}
                  sx={{
                    textUnderlineOffset: "6px",
                    fontWeight: "600",
                    textDecoration: "underline",
                    fontSize: 16,
                  }}
                >
                  Message for students:
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 4 }}>
                <Typography
                  variant="body1"
                  color={"primary.main"}
                  sx={{ textIndent: "2rem" }}
                  fontSize={"1rem"}
                >
                  Dear Students, Welcome to Progressive Education Society's
                  Modern College of Physiotherapy. The society has been making
                  noteworthy progress for the past 79 years along with the
                  notable path and principles laid down by the eminent
                  predecessors such as Guruwarya Late S.R. Kanitkar, Late Shri
                  V.T. Tatke and Late Shri M.G. Chaphekar who were illustrious
                  incarnations of ceaseless hard work and sacrifice. Progressive
                  Education Society is proud to possess the glowing tradition of
                  these stalwarts.
                </Typography>
                <Typography
                  variant="body1"
                  color={"primary.main"}
                  sx={{ textIndent: "2rem" }}
                  fontSize={"1rem"}
                >
                  The two remarkable words that appear in the names of the
                  society and it's educational institutions are "Progressive"
                  and "Modern". The inclusion of theses words was certainly with
                  some notable intentions, which serves as a bright beacon for
                  the society to follow with determination.
                </Typography>
                <Typography
                  variant="body1"
                  color={"primary.main"}
                  sx={{ textIndent: "2rem" }}
                  fontSize={"1rem"}
                >
                  The aims and objects of the progressive education society as
                  laid down in it's constitution are, "to impart knowledge to
                  the rising generations of the country and particularly to the
                  resident of Maharashtra state, an efficient education
                  embodying scientific, technical and ethical training for
                  providing a quality in service".
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded>
              <AccordionSummary
                id="panel1-header"
                expandIcon={<ExpandMoreIcon />}
              >
                <Typography
                  variant="body2"
                  color={"primary.main"}
                  sx={{
                    textUnderlineOffset: "6px",
                    fontWeight: "600",
                    textDecoration: "underline",
                    fontSize: 16,
                  }}
                >
                  Career Profile:
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container columns={{ xs: 1, md: 2 }} spacing={2}>
                  <Grid item xs={12}>
                    {data.career.map((message, i) => (
                      <Stack
                        direction="row"
                        alignItems={"flex-start"}
                        justifyContent={"flex-start"}
                        mb={1}
                        sx={{ px: { xs: "2rem", md: "1rem" } }}
                        spacing={1}
                      >
                        <Circle
                          fontSize="small"
                          sx={{ color: "black", scale: "80%", pt: 0.5 }}
                        />

                        <Typography
                          variant="body2"
                          textAlign="justify"
                          fontSize={"1rem"}
                          color="primary.main"
                        >
                          {message}
                        </Typography>
                      </Stack>
                    ))}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};

export default Chairman;
